import { Component, OnInit,ViewEncapsulation } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import { SharedDataService } from 'app/shared-data.service';
import * as forge from 'node-forge';
import { Http, Headers, RequestOptions } from '@angular/http';

@Component({
   selector: 'ms-lockscreen',
   templateUrl:'./lockscreen-component.html',
   styleUrls: ['./lockscreen-component.scss'],
   encapsulation: ViewEncapsulation.None,
})
export class LockScreenComponent {
	
  username: string;

  constructor(
    private router: Router,
    private http: Http,
    private _Activatedroute:ActivatedRoute,
    public sharedDataService: SharedDataService,
  ) { }

  sessionID:string;
  transactionID:string;
  orderID:string;
  currency:string;
  otp:string;
  ngOnInit(){
    this._Activatedroute.queryParams.subscribe(params => { 
      if (params.session_id) this.sessionID = params.session_id;
      if (params.transaction_id) this.transactionID = params.transaction_id;
      if (params.order_id) this.orderID = params.order_id;
      if (params.currency) this.currency = params.currency;
      if (params.email) this.cardholderEmail = params.email;
      if (params.auth) this.otp = params.auth;
    });
  }

  private privateKeyPem: string = `
  -----BEGIN RSA PRIVATE KEY-----
MIIEogIBAAKCAQEAmlVSFsBwYvLLe5jPnSLSZ0jgjMstI+eWow/wKg53PPSZ3ThF
/IKZkctpp2JtdKXQgFgYn3cVdlkqWyCJX6Hyj1bAfOD9YqjcSN0bi9ewXt1uLvfO
to9SoMz4Sp142hvS6xKSatg+a2g49kSjLhR9MAQSuFux9tUR1izhcTmOLEHjPlzc
N9LXn3sY7nogNBylXNNcSmjnLd3P/xIbJevzm+ykAElJtN3yDHIqWGXYKnnun1iX
u3hcqhiUJCs8/A6fJxT6fBydGIfoTpvlOkAUOicnUnl4IWtXOcXn3lZf5ZoGlwGS
CNw4JeB1/WdbkR8++tnG+sVxVfJ1MzjTx/x7jwIDAQABAoIBADAT5D6yNFCe0kTu
lb6d2m3ShiFWKfnFa2fgzzBK0Vpr2ILRxPuks7J3a7J5Nx/fh9RznTgQIN99Z3R7
7k+cY7PDkrNUY5sYf4czWiF2T7s9v9Vh3UOB4nu1XqPf6oYHpO0WHAas1sUe8p/F
QhBY0abjnfFQn2AFgEj4MkLTazbd0iALGYHa+nA5R6WsA2FbTxqpLdnfKXAsRsZV
GFsmD4DSuoVJDDR6NB2PrpKoesH58ZBpsU1cd5XogdIG/Zf8qfnrHPvZBjg4xY+j
p3Jn4S/6cqSgUHnU4KLpwI3okAILRMEE4CRy2u6C0zWVKZqJt8D0/LPvFNpr0mA2
NjNwsgECgYEA6qEEKhqlYOlCD7trEHk7reLmsjG8mHvQn2mQYlnmjguzRrTTb+rr
P8FvyluydggUmNWHcmrMnjjVfhh0teqmIGcE/Jh7MswJeT93o2fX2FYO5iaXVd8A
c+lYr7HYTCi7vNzKP4+byGXG4ar/RUvB3T1OCxOOp26/LpwoDiGYsCsCgYEAqGQA
gDIv6u9a19u9fk71OWhdthiCiRYXvGNm2rMpxvtUtUT+3Do4AXF7ZsdyNkQ+KyAl
YzhsSKUFzEiX1iC6U4hsy6UpA1yOgwQxNYH21axgC9D2VUrG2C6XTr+ja3q4fCGe
bgsR5hppAY7kFaw+qDotEUImoNsnepoq+UpqjC0CgYAgwvDw7B2RhaCKz9GoUDVM
F3W9BgLei9NanwPhJ8pwpSOYSOGJLBVDJsB0Ug9+Oayelpo+GLmPkkIFRGbvi988
gQYKO0RgmGruOjV7ZKGX/JRCALt66xOGG9wdVEjugXWNborzCxtmhQebNSRFyck9
GjVOiKGPsYASgw14w6otVwKBgGKNRI3C0bCaLXywKpNF+teCcXYlmiBJQdMMCiJt
QUInzkfY/aA+opCVrjdU+08vWYM76SXM2/MYQfBxfAviU6qX6bS2EO7auL2NMo+y
ZJhhrkS8I69/eCkF+6AnIKnCxT5BHswgxnT5eANlcbANgw5KHh4/rQPvv4dNu2Dz
YLBxAoGAOp3fyD+NovjOMBnzXMsUtfauNZpeYglyT1ax3whlMZMSN12OegHINGjQ
WRT6u6XygjqxyRFve8rRE8+ovjjwW9c/Nljx2aS8IdJlFTTUJ0dwoSht66FsXlFp
NUVKJmChYeLV6SoLqUe4tSx8lS5J5UcT12oMg7agT5z+ZRsqS4g=
-----END RSA PRIVATE KEY-----
  `;

  async decryptMessage(){
    const privateKey = forge.pki.privateKeyFromPem(this.privateKeyPem);
    const encryptedMessage = forge.util.decode64(this.otp);
    const decryptedMessage = privateKey.decrypt(encryptedMessage, 'RSA-OAEP');
    
    return decryptedMessage;
  }

  returnHeaders(){
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', this.auth64);
    headers.append('x-location', this.sharedDataService.locationSub);
    headers.append('x-device-info', this.sharedDataService.getBrowserName());

    return headers;
  }

  ngAfterViewInit(){
    
    
    
    
    this.concludePayment();
  }

  verifyingOTP = true;
  cardPaymentSuccessful = false;
  successResponse;
  failureResponse;
  failureResponseMessage;
  cardholderEmail = 'the cardholder email';
  auth64;
  async concludePayment(){
      // let finalpaymentBody = sessionStorage.getItem('tempPaymentBody');
      let finalpaymentBody = {
        "Session_ID": this.sessionID,
        "External_Payment_Identifier": this.orderID,
        "Transaction_ID": this.transactionID,
        "Currency_Short_Symbol": this.currency
      }
      
      
      if (!this.sharedDataService.encoded64BitAuth && !this.otp) {
        this.cardPaymentSuccessful = false;
        this.failureResponse = 'UNAUTHORIZED';
        this.failureResponseMessage = 'Not Authorized To Verify Payment';
        this.verifyingOTP = false;
        return;
      }

      let finalStepConfirmation;
      if (this.otp && !this.sharedDataService.encoded64BitAuth) {
        let decryptedOTP = await this.decryptMessage();
        try {
          decryptedOTP = JSON.parse(decryptedOTP);          
        } catch (error) {
          this.cardPaymentSuccessful = false;
          this.failureResponse = 'INVALID AUTHORIZATION';
          this.failureResponseMessage = 'Invalid Authorization';
          this.verifyingOTP = false;
        }

        if (!decryptedOTP.credentials) {
          this.cardPaymentSuccessful = false;
          this.failureResponse = 'INVALID AUTHORIZATION';
          this.failureResponseMessage = 'Invalid Authorization';
          this.verifyingOTP = false;
          return;
        }

        // this.sharedDataService.login_email = decryptedOTP.username;
        this.auth64 = 'Basic ' + decryptedOTP.credentials;
        let requestOptions = new RequestOptions();
        requestOptions.headers = this.returnHeaders();
    
        try{
          finalStepConfirmation = await this.http.post(this.sharedDataService.apiUrl + '/paid_services_gt_mastercard?' + this.sharedDataService.getActivityForUrl('Financial Management', 'Verify OTP Transaction (External)', 'Pay Bill', 'Pay Invoice/Bill'), finalpaymentBody, requestOptions).toPromise();
        }
        catch (error) {
          finalStepConfirmation = error;
          this.cardPaymentSuccessful = false;
          this.failureResponse = 'NETWORK ERROR';
          this.failureResponseMessage = 'Network Error';
          this.verifyingOTP = false;
          return;
        }
      } else {
        finalStepConfirmation = await this.sharedDataService.httpPostAsync('/paid_services_gt_mastercard?' + this.sharedDataService.getActivityForUrl('Financial Management', 'Verify OTP Transaction', 'Pay Bill', 'Pay Invoice/Bill'), finalpaymentBody);
      }
      if (finalStepConfirmation.status !== 200) {
        this.sharedDataService.handleErrorMessage(finalStepConfirmation);
        return;
      }
      let finalResponse = finalStepConfirmation.json().response;
      
      if (!finalResponse.error) {
        if (finalResponse.result == 'SUCCESS') {
          this.successResponse = finalResponse.response.gatewayCode;
          this.cardPaymentSuccessful = true;
        } else {
          if (finalResponse.response) {
            this.failureResponse = finalResponse.response.gatewayCode;
            this.failureResponseMessage = this.underscoreToCamelCase(finalResponse.response.gatewayRecommendation);              
          }
          else{
            this.failureResponse = 'UNKNOWN ERROR';
            this.failureResponseMessage = 'Unknown Error';
          }
          this.cardPaymentSuccessful =  false;
        }
        this.verifyingOTP = false;
      }
      else{
        this.cardPaymentSuccessful = false;
        this.failureResponse = finalResponse.error.cause;
        this.failureResponseMessage = 'Error Verifying OTP';
        this.verifyingOTP = false;
      }

  }

  underscoreToCamelCase(str) {
    return str.replaceAll('_', ' ');
    // return str.replace(/_/g, ' ').replace(/\s(.)/g, function(match) {
    //   return match.toUpperCase();
    // }).replace(/\s/g, '').replace(/^(.)/, function(match) {
    //   return match.toLowerCase();
    // });
  }
	
}






// WEBPACK FOOTER //
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/app/session/lockscreen/lockscreen.component.ts